import { render } from "./AppRailNew.vue?vue&type=template&id=84f86122&scoped=true"
import script from "./AppRailNew.vue?vue&type=script&lang=js"
export * from "./AppRailNew.vue?vue&type=script&lang=js"

import "./AppRailNew.vue?vue&type=style&index=0&id=84f86122&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84f86122"]])

export default __exports__